import { FC } from 'react'
import { useLocation } from 'react-router-dom'

export const HomeIcon: FC = () => {
  const location = useLocation()
  const isActive = location.pathname === '/'
  
  return (
    <svg width="32" height="36" viewBox="0 0 32 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 0L0 12V36H10V22H22V36H32V12L16 0Z"
        fill={isActive ? 'white' : '#B98CA4'}
      />
    </svg>
  )
}
